import React, { useState, useEffect } from 'react'
import { useTheme } from '@mui/material'
import Box from '@mui/material/Box'
import Stack from '@mui/material/Stack'
import IconButton from '@mui/material/IconButton'
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline'
import defaultTexts from '../../texts/texts'
import constants from '../../config/constants'
import { request } from '../../_network/request'
import { externalAppsURLs } from '../../_network/apiUrls'
import ExternalApplicationAdd from './ExternalApplicationAdd'
import ExternalApplicationDelete from './ExternalApplicationDelete'
import ExternalApplicationsItem from './ExternalApplicationsItem'
import CustomDialog from '../_common/CustomDialog'
import CustomBackdrop from '../_common/CustomBackdrop'

const ExternalApplicationsWrapper = (props) => {
  const theme = useTheme()

  const [isLoading, setIsLoading] = useState(false)
  const [applications, setApplications] = useState([])
  const [editApplication, setEditApplication] = useState(null)
  const [addApplicationDialogOpen, setAddApplicationDialogOpen] = useState(false)
  const [editApplicationDialogOpen, setEditApplicationDialogOpen] = useState(false)
  const [deleteApplicationDialogOpen, setDeleteApplicationDialogOpen] = useState(false)
  const [fetchApplications, setFetchApplications] = useState(1)

  const wrapperStyle = {
    background: theme.palette.aliceBlue,
    borderRadius: '50px 20px 20px 20px',
    boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
    marginTop: '30px',
  }

  const labelStyle = {
    height: '60px',
    background: theme.palette.oxfordBlue,
    color: 'white',
    fontSize: '20px',
    fontWeight: '500',
    borderRadius: '50px 0px',
    padding: '0px 10%',    
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  }

  const handleAddApplicationDialogOpen = () => {
    setAddApplicationDialogOpen(true)
  }

  const handleAddApplicationDialogClose = () => {
    setAddApplicationDialogOpen(false)
  }

  const handleEditApplicationDialogOpen = (user_id) => {
    setEditApplicationDialogOpen(true)
    setEditApplication(applications.find(item => item.id === user_id))
  }

  const handleEditApplicationDialogClose = () => {
    setEditApplicationDialogOpen(false)
    setEditApplication(null)
  }

  const handleDeleteApplicationDialogOpen = (user_id) => {
    setDeleteApplicationDialogOpen(true)
    setEditApplication(applications.find(item => item.id === user_id))
  }

  const handleDeleteApplicationDialogClose = () => {
    setDeleteApplicationDialogOpen(false)
    setEditApplication(null)
  }

  useEffect(() => {
      const fetchApplicationsData = async () => {
        setIsLoading(true)
  
        const url = constants.core_service_domain + '/' + externalAppsURLs.getExternalApps      
        const request_data = { url, method: 'GET' }    
        const response = await request(request_data)
        
        if (response && response.status_code && response.status_code < 400 && response.data && response.data.length > 0) {
          setApplications(response.data)
        } else {
          setApplications([])
        }
  
        setIsLoading(false)
      }
  
      fetchApplicationsData()
    }, [fetchApplications])
  
  return (
    <>
      { isLoading && <CustomBackdrop open={isLoading} /> }

      <Box sx={wrapperStyle}>
        <Stack
          direction='row'
          alignItems='center'
          justifyContent='flex-start'
        >
          <Box sx={labelStyle}>
            <Box>{defaultTexts.registeredExternalApplications}</Box>
            <IconButton sx={{ color: 'white' }} onClick={handleAddApplicationDialogOpen}>
              <AddCircleOutlineIcon />
            </IconButton>
          </Box>
        </Stack>

        {
          applications.length > 0 &&
          <Box sx={{ padding: '40px 20px' }}>
            {
              applications.map((item, index) => (
                <ExternalApplicationsItem
                  key={index}
                  {...item}
                  setIsLoading={setIsLoading}
                  handleEditApplicationDialogOpen={handleEditApplicationDialogOpen}
                  handleDeleteApplicationDialogOpen={handleDeleteApplicationDialogOpen}
                />
              ))
            }
          </Box>
        }        
      </Box>

      <CustomDialog
        open={addApplicationDialogOpen}
        onClose={handleAddApplicationDialogClose}
        dialogTitle={{
          title: defaultTexts.registerNewApplication,
          sx: {
            color: theme.palette.violetsAreBlue,
            fontSize: '22px',
            fontWeight: '500',
          },
        }}
        closeIconColor={theme.palette.violetsAreBlue}
			>
        <ExternalApplicationAdd
          handleAddApplicationDialogClose={handleAddApplicationDialogClose}
          setFetchApplications={setFetchApplications}
          applications={applications}
        />
      </CustomDialog>

      <CustomDialog
        open={editApplicationDialogOpen}
        onClose={handleEditApplicationDialogClose}
        dialogTitle={{
          title: defaultTexts.updateApplication,
          sx: {
            color: theme.palette.violetsAreBlue,
            fontSize: '22px',
            fontWeight: '500',
          },
        }}
        closeIconColor={theme.palette.violetsAreBlue}
			>
        <ExternalApplicationAdd
          handleAddApplicationDialogClose={handleEditApplicationDialogClose}
          setFetchApplications={setFetchApplications}
          applications={applications}
          currentRecord={editApplication}
        />
      </CustomDialog>

      <CustomDialog
        open={deleteApplicationDialogOpen}
        onClose={handleDeleteApplicationDialogClose}
        dialogTitle={{
          title: defaultTexts.deleteApplication,
          sx: {
            color: theme.palette.violetsAreBlue,
            fontSize: '22px',
            fontWeight: '500',
          },
        }}
        closeIconColor={theme.palette.violetsAreBlue}
      >
        <ExternalApplicationDelete
          handleDeleteApplicationDialogClose={handleDeleteApplicationDialogClose}
          editApplication={editApplication}
          setFetchApplications={setFetchApplications}
        />
      </CustomDialog>
    </>
  )
}

export default ExternalApplicationsWrapper